<div class="fx-time-condition">
  <div class="filter">
    <div style="text-align: end">
      <div class="timeframe">
        <fx-timeframe
          [selectedTimeframe]="timeInfo.tf"
          [tfs]="['customize', 'hour', 'day', 'week']"
          (timeframeChanged)="onTimeFrameChanged($event)"
        ></fx-timeframe>
      </div>
      <div class="daterange" *ngIf="range.value && isEnableChangeRangeTime">
        <mat-form-field appearance="fill">
          <mat-label>{{ "" }}</mat-label>
          <mat-date-range-input
            [formGroup]="range"
            [rangePicker]="picker"
            [disabled]="!isEnableChangeRangeTime"
            [dateFilter]="datepickerFilter"
            [fo]
          >
            <input
              matStartDate
              formControlName="start"
              [required]="true"
              placeholder="MM/DD/YYYY"
            />
            <input
              matEndDate
              formControlName="end"
              [required]="true"
              placeholder="MM/DD/YYYY"
            />
          </mat-date-range-input>
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>
      <div class="filter-action group-btn" *ngIf="isEnableChangeRangeTime">
        <button class="btn btn-primary rounded" (click)="onApplyTime()" [disabled]="range.invalid">
          {{ "Apply" }}
        </button>
      </div>
    </div>
  </div>
</div>
